import * as React from "react";

/** Classic stethoscope – simple “U” tube with chestpiece, clean and modern */
export function StethoscopeClassic(props) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* The "U" shaped tube */}
      <path d="M20 16c0 10 8 18 18 18s18-8 18-18" />
      {/* Connection line down to chestpiece */}
      <path d="M38 34v8c0 6-4 10-10 10h-4" />
      {/* Chestpiece */}
      <circle cx="22" cy="52" r="5" />
      <circle cx="22" cy="52" r="2" fill="currentColor" />
    </svg>
  );
}

/** US flag with subtle red/white/blue (faint), classic stripes/canton. */
export function USFlagFaint(props) {
  const W = 190;
  const H = 100;
  const stripes = Array.from({ length: 13 });
  const cantonH = (H * 7) / 13;
  const cantonW = 76;

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* outer border */}
      <rect x="2" y="2" width={W - 4} height={H - 4} rx="3" stroke="rgba(43,82,136,0.25)" />
      {/* faint stripes (red lines, white implied) */}
      {stripes.map((_, i) => {
        const y = 2 + (i * (H - 4)) / 13;
        const strokeColor = i % 2 === 0 ? "rgba(178,34,52,0.18)" : "rgba(255,255,255,0.12)";
        return <line key={i} x1="2" x2={W - 2} y1={y} y2={y} stroke={strokeColor} />;
      })}
      {/* canton */}
      <rect x="2" y="2" width={cantonW} height={cantonH} fill="rgba(60,59,110,0.22)" stroke="none" />
      {/* dotted star field */}
      {Array.from({ length: 9 }).map((_, row) => {
        const isEven = row % 2 === 0;
        const count = isEven ? 6 : 5;
        return Array.from({ length: count }).map((_, col) => {
          const xBase = 6 + (col * (cantonW - 12)) / (count - 1);
          const x = isEven ? xBase : xBase + (cantonW - 12) / (count * 2);
          const y = 6 + (row * (cantonH - 12)) / 8;
          return <circle key={`${row}-${col}`} cx={x} cy={y} r="1.6" fill="rgba(255,255,255,0.65)" stroke="none" />;
        });
      })}
    </svg>
  );
}
